<template>
  <list-input-text
    type="password"
    placeholder="新しいパスワード"
    :get="get"
    :set="set"
  />
</template>

<script>
import ListInputText from '@/lib/List/Input/Text'

export default {
  components: {
    ListInputText
  },

  computed: {
    get () {
      return () => {
        return this.$store.state.passwordChange.password
      }
    },

    set () {
      return (value) => {
        this.$store.commit('passwordChange/setPassword', value)
      }
    }
  }
}
</script>
